













































import {
  Vue,
  Component,
  Watch
} from "@/shared/vuepack";

import AllegacyFooterCash from "@/employee/components/shared/AllegacyFooterCash.vue";
import AllegacyFooterInvestment from "@/employee/components/shared/AllegacyFooterInvestment.vue";

import AvidiaFooterCash from "@/employee/components/shared/AvidiaFooterCash.vue";
import AvidiaFooterInvestment from "@/employee/components/shared/AvidiaFooterInvestment.vue";

import ElementsFooterCash from "@/employee/components/shared/ElementsFooterCash.vue";
import ElementsFooterInvestment from "@/employee/components/shared/ElementsFooterInvestment.vue";

import UcbFooterCash from "@/employee/components/shared/UcbFooterCash.vue";
import UcbFooterInvestment from "@/employee/components/shared/UcbFooterInvestment.vue";

import UmbFooterCash from "@/employee/components/shared/UmbFooterCash.vue";
import UmbFooterInvestment from "@/employee/components/shared/UmbFooterInvestment.vue";
import { useUserStore } from "@/shared/store/user";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { usePortalCustomizationStore } from "@/shared/store/portalCustomization";

@Component({
  components: {
    AllegacyFooterCash,
    AllegacyFooterInvestment,

    AvidiaFooterCash,
    AvidiaFooterInvestment,

    ElementsFooterCash,
    ElementsFooterInvestment,

    UcbFooterCash,
    UcbFooterInvestment,

    UmbFooterCash,
    UmbFooterInvestment
  }
})
export default class Footer extends Vue {


  userStore = useUserStore();
  custodianSettingStore = useCustodianSettingsStore();
  portalCustomizationStore = usePortalCustomizationStore();

  mounted (): void {
    this.custodianSettingStore.getCustodianSettings();
  }

  get supportPhone (): string {
    return this.portalCustomizationStore.supportInfo.supportPhone;
  }

  get supportPhoneFormatted (): string {
    return `tel:+1-${this.portalCustomizationStore.supportInfo.supportPhone}`;
  }

  get aboutUsUrl (): string {
    return this.portalCustomizationStore.supportInfo.supportWebsite;
  }

  get displayFooterTemplate (): boolean {
    if (this.custodianSettingStore.footerTemplate) {
      return true;
    }

    return false;
  }

  get footerTemplateCash (): string {
    return this.custodianSettingStore.footerTemplate + "Cash";
  }

  get footerTemplateInvestment (): string {
    return this.custodianSettingStore.footerTemplate + "Investment";
  }

  get supportEmail (): string {
    return `mailto:${this.portalCustomizationStore.supportInfo.supportEmail}`;
  }

  get supportName (): string {
    return `${this.portalCustomizationStore.supportInfo.displayName} Customer Support`;
  }

  get legalFooterIsShown () {
    return this.custodianSettingStore.displayFooterLegalSection || this.custodianSettingStore.isHsaBankCustodian;
  }
}
